import { formatBytes } from "./format";

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
const ACCEPTED = [".xlsx", ".csv"];
const REJECTED: Record<string, string> = {
  ".xlsm": "Macro-enabled workbooks (.xlsm) aren't accepted. Save the file as .xlsx or .csv.",
  ".xlsb": "Binary workbooks (.xlsb) aren't supported. Save the file as .xlsx or .csv.",
  ".xls": "Legacy .xls files aren't supported. Save the file as .xlsx or .csv.",
};

/** Client-side pre-check for instant feedback. The server re-checks everything. */
export function checkFile(file: File): string | null {
  const name = file.name.toLowerCase();
  const extension = name.includes(".") ? name.slice(name.lastIndexOf(".")) : "";
  if (REJECTED[extension]) return REJECTED[extension];
  if (!ACCEPTED.includes(extension)) return "Choose an .xlsx or .csv file.";
  if (file.size === 0) return "That file is empty.";
  if (file.size > MAX_UPLOAD_BYTES) return `That file is ${formatBytes(file.size)}; the limit is 25 MB.`;
  return null;
}
